/**
 * @generated SignedSource<<3ae04ddd3ebe9f370a776da844cc4977>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarTeamEventEditComponent_storeCalendars$data = ReadonlyArray<{
  readonly color: string;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventEditComponentSelectCalendarPopover_storeCalendars">;
  readonly " $fragmentType": "CalendarTeamEventEditComponent_storeCalendars";
}>;
export type CalendarTeamEventEditComponent_storeCalendars$key = ReadonlyArray<{
  readonly " $data"?: CalendarTeamEventEditComponent_storeCalendars$data;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventEditComponent_storeCalendars">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CalendarTeamEventEditComponent_storeCalendars",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CalendarTeamEventEditComponentSelectCalendarPopover_storeCalendars"
    }
  ],
  "type": "StoreCalendar",
  "abstractKey": null
};

(node as any).hash = "4757007d04b82bb01dbca146bf2395be";

export default node;
